import { HubConnectionState } from '@microsoft/signalr'
import { useEffect } from 'react'
import { OrderStatusUpdatedEventPayload, parseNumericOrderStatus } from '#entities/order'
import { wsClient } from '#shared/api'
import { getCurrentUserRoleInfo, keycloak } from '#shared/lib/auth'
import { showNotification } from '#shared/lib/notifications'

interface NotificationsDispatcherProps {
  children: React.ReactNode
}

const tryStartWsConnection = () => {
  if (!keycloak.tokenParsed) return

  if (wsClient.state === HubConnectionState.Disconnected) {
    wsClient.start()
  }
}

export default function NotificationsDispatcher({ children }: NotificationsDispatcherProps) {
  useEffect(() => {
    tryStartWsConnection()
  }, [])

  useEffect(() => {
    const intervalId = setInterval(() => {
      tryStartWsConnection()
    }, 1000)

    return () => clearInterval(intervalId)
  })

  useEffect(() => {
    const roleInfo = getCurrentUserRoleInfo()

    const onOrderStatusUpdated = async (payload: OrderStatusUpdatedEventPayload) => {
      const orderStatus = parseNumericOrderStatus(payload.eventBody.status)

      if (orderStatus === 'ARRIVING' && roleInfo.role === 'client') {
        return showNotification('Найден исполнитель для заказа', 'success')
      }

      if (orderStatus === 'CANCELLED') {
        return showNotification('Заказ отменен', 'danger')
      }
    }

    wsClient.on('order-status-updated-v1', onOrderStatusUpdated)

    return () => wsClient.off('order-status-updated-v1', onOrderStatusUpdated)
  })

  return children
}
